import { createContext, useContext, useRef, useEffect, useMemo } from 'react';
import { useAuth } from './AuthContext';

const DataCacheContext = createContext(null);

export function DataCacheProvider({ children }) {
  const cacheRef = useRef({});
  const { organization } = useAuth();

  // Clear cache when organization changes
  useEffect(() => {
    cacheRef.current = {};
  }, [organization?.id]);

  const value = useMemo(() => ({
    getCachedData: (key) => cacheRef.current[key] || null,
    setCachedData: (key, data) => { cacheRef.current[key] = data; },
  }), []);

  return (
    <DataCacheContext.Provider value={value}>
      {children}
    </DataCacheContext.Provider>
  );
}

export function useDataCache() {
  const context = useContext(DataCacheContext);
  if (!context) {
    throw new Error('useDataCache must be used within a DataCacheProvider');
  }
  return context;
}
